
const Product_filter_reducer=(state ="all", action)=>{
  switch (action.type) {
    case "all":
      return "all";
    case "discounted":
      return "discounted";
    case "free":
      return "free";
    default:
      return state;
  }
}

export default Product_filter_reducer;